/*
 * Purpose: Lost passkey / device recovery page
 * Last modified: 2026-06-28 | Agent
 * Completeness: 90
 */
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BrandMark } from '@/components/brand/BrandMark';
import { LostKeyRecoveryPanel } from '@/components/auth/LostKeyRecoveryPanel';
import { AUTH_CONFIG } from '@/lib/auth-config';
import { PRODUCT_NAME } from '@/lib/productTerms';
import { Button } from '@/components/ui/button';

export default function AuthLostKey() {
  return (
    <div className="auth-gate-overlay min-h-screen flex flex-col bg-[var(--auth-bg)]">
      <header className="shrink-0 border-b border-[var(--auth-border)]/60 bg-[var(--auth-surface)]/80 backdrop-blur-sm">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
          <Link to="/" className="flex items-center gap-2 min-w-0">
            <BrandMark size={24} className="shrink-0" ghostAccent="darker" />
            <span className="ab-brand-wordmark text-sm text-[var(--auth-fg)]">{PRODUCT_NAME}</span>
          </Link>
          <Button variant="ghost" size="sm" asChild>
            <Link to={AUTH_CONFIG.signInPath}>
              <ArrowLeft className="h-4 w-4 mr-1" />
              Sign in
            </Link>
          </Button>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center p-4 sm:p-8">
        <LostKeyRecoveryPanel next={AUTH_CONFIG.postLoginPath} />
      </main>
    </div>
  );
}
